import React from 'react';

export default function PublicLayout({ children }: { children: JSX.Element }) {
  return <React.Fragment>{children}</React.Fragment>;
}
